import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';

interface IStoreMap {
    namespace: string;
    property: string;
    data: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreSync',
  props: {
    namespace: null,
    property: null,
    data: null
  },
  setup(__props: any) {

const props = __props as {
    namespace: string;
    property: string;
    data: any;
}



const $store = getCurrentInstance().proxy.$store;
$store.commit('sync', { namespace: props.namespace, property: props.property, data: props.data }, { root: true });


return { __sfc: true,props, $store }
}

})